import React from 'react';

import { createSvgIcon } from '@mui/material/utils';

const LogbookIcon = createSvgIcon(
    <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.545 1.50251C14.4473 1.40452 12.8855 0 10.7379 0C9.24109 0 8.06968 0.653266 7.38636 1.11055C6.70304 0.653266 5.43402 0.0653266 4.09992 0C2.0825 0 0.390469 1.40452 0.32539 1.50251L0 1.69849V13L1.20394 12.1181C1.20394 12.1181 2.60312 10.9749 4.03484 10.9749C5.43402 10.9749 6.86574 12.1181 6.86574 12.1181L7.32129 12.4121L7.74429 12.1181C8.19984 11.8241 9.69664 10.9749 10.6728 10.9749C11.5592 10.9749 12.8763 11.7242 13.4643 12.0588L13.5688 12.1181L14.7727 12.8693V1.69849L14.545 1.50251ZM4.09992 9.50503C3.15987 9.50503 2.25211 9.8616 1.50533 10.1549L1.4968 10.1583V2.38442C1.95234 2.09045 2.99359 1.50251 4.03484 1.50251C5.14117 1.56784 6.18242 2.09045 6.63797 2.38442V10.093C5.98718 9.799 5.07609 9.50503 4.09992 9.50503ZM10.7379 9.40703C11.6164 9.40703 12.5275 9.799 13.2759 10.1583H13.341V2.38442C12.9831 2.09045 12.0069 1.50251 10.803 1.50251C9.63156 1.50251 8.65539 2.09045 8.19984 2.38442V10.1583C8.88316 9.799 9.85933 9.40703 10.7379 9.40703Z"
    />,
    'logbook'
);

export default LogbookIcon;
